import { ISColumn } from "../is-table/is-table";
import { ISFilterAPI, ISPagination } from "../models/api";

export class ISSelectDatasource {
    constructor(
        public columns: ISColumn[],
        public body?: any[],
        public pagination: ISPagination = { pageSize: 10, page: 1 },
        public totalItems: number = 0,
        public codeBTN: boolean = false,
        public apiUrl: string | undefined = undefined,
        public filters?: ISFilterAPI[],
        public codeBtnId: string | null = null,
        public codeBtnDialog: boolean = false
    ) { }
}

export type HttpMethod = 'GET' | 'POST' | ''
